import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/organizations-interest-page/page.js");
